/**
 * @generated SignedSource<<c7d5a1512c659d4c34ac196d933328b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SettlementViewFinalizeSettlementMutation$variables = {
  settlementIdentifier: string;
};
export type SettlementViewFinalizeSettlementMutation$data = {
  readonly finalizeSettlement: {
    readonly id: string;
    readonly status: string;
    readonly updatedAt: any | null | undefined;
  };
};
export type SettlementViewFinalizeSettlementMutation = {
  response: SettlementViewFinalizeSettlementMutation$data;
  variables: SettlementViewFinalizeSettlementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "settlementIdentifier"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "settlementIdentifier",
            "variableName": "settlementIdentifier"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Settlement",
    "kind": "LinkedField",
    "name": "finalizeSettlement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettlementViewFinalizeSettlementMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettlementViewFinalizeSettlementMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "57c6a57572a1aa9d95db155089335ebd",
    "id": null,
    "metadata": {},
    "name": "SettlementViewFinalizeSettlementMutation",
    "operationKind": "mutation",
    "text": "mutation SettlementViewFinalizeSettlementMutation(\n  $settlementIdentifier: String!\n) {\n  finalizeSettlement(input: {settlementIdentifier: $settlementIdentifier}) {\n    id\n    status\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "f788907c894d9c858da9be968e6baa4f";

export default node;
